import api from "../config/api";
import handleResponse from "./ResponseHandler";

function getInspections(idToken: string) {
    return new Promise(function (resolve, reject) {
        const options = {
            method: "get",
            headers: {
                Accept: "application/json, text/plain, */*",
                idtoken: idToken,
                "Content-Type": "application/json"
            }
        };
        fetch(api.getInspections, options)
            .then((response) => handleResponse(response))
            .then((response) => response.json())
            .then((data) => {
                resolve(data);
            })
            .catch((response) =>
                reject({
                    status: response.statusText,
                    statusCode: response.statusCode
                })
            );
    });
}

export default getInspections;
